<template>
  <base-dialog-form ref="uploadUsersDialog" :title="$t('import_users_csv')" color="secondary"
    icon="mdi-account-arrow-up">
    <v-row>
      <v-col>
        <v-select v-model="encoding" :items="encodingList" label="Encoding" required color="primary"
          persistent-hint></v-select>
      </v-col>
      <v-col>
        <v-file-input dense v-model="files" @change="onFileChange" color="primary" :label="$t('import_users_csv')"
          :show-size="true" prepend-icon="mdi-file-delimited-outline" outlined accept="text/csv" /></v-col>
      <v-col>
        <v-btn class="mx-2" @click="users = []" :disabled="!users || users.length === 0" color="warning">
          <v-icon class="mr-2">mdi-backspace-outline</v-icon>{{ $t("clear") }}</v-btn>
        <v-btn class="mx-2" @click="loadData(true)" :disabled="!users || users.length === 0 || selected.length === 0"
          color="primary">
          <v-icon class="mr-2">mdi-account-plus</v-icon>{{ $t("import_users_in_portal") }}</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" v-if="users">
        <DataTables :showSelect="true" :headers="headers" v-model="selected" :tableData="users" itemKey="id">
        </DataTables>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" v-if="users && users.length > 0"> </v-col>
    </v-row>
  </base-dialog-form>
</template>

<script>
import DataTables from "@/components/base/DataTables.vue";

export default {
  name: "upload-users",
  components: { DataTables },
  props: {},
  data() {
    return {
      files: null,
      users: null,
      selected: [],
      csv: null,
      encoding: "utf-8",
      encodingList: [
        { value: "utf-8", text: "UTF-8" },
        { value: "windows-1252", text: "Windows (Western Latin)" },
      ],
      headers: [
        { text: "", value: "status", type: "icons" },
        { text: this.$t("error"), value: "msgTxt" },
        { text: this.$t("portal"), value: "portal" },
        { text: this.$t("surname"), value: "surname" },
        { text: this.$t("name"), value: "name" },
        { text: this.$t("sex"), value: "sex" },
        { text: this.$t("fiscal_code"), value: "cFiscale" },
        { text: this.$t("email"), value: "email" },
        { text: this.$t("birth_date"), value: "birthDate", type: "date" },
        { text: this.$t("birth_city"), value: "birthCity", type: "text" },
        { text: this.$t("residence_address"), value: "resCity" },
        { text: this.$t("telephone"), value: "telephone" },
      ],
    };
  },
  methods: {
    loadData(toImport = false) {
      let _ = this;
      //let b64csv = btoa(_.csv)
      let params = {
        csv: _.csv,
      };
      if (toImport) params.toImport = _.selected;
      _.selected = [5];
      _.chiamataAxios("PUT", "/auth/portal/csv/importFileUtenti", {
        body: params,
        dialogLoader: true,
        secTimeout: 500,
      }).then((response) => {
        if (response.msg.esito) {
          _.users = response.data.map((user) => {
            user.disabled = !user.valido || user.giaPresente;
            if (user.importato || user.giaPresente) {
              user.status = [{ icon: "mdi-check-circle", color: "success" }];
            } else if (!user.valido && !user.masterId) {
              user.status = [{ icon: "mdi-close-circle", color: "error" }];
            } else if (!user.valido && user.masterId) {
              user.status = [{ icon: "mdi-alert", color: "warning" }];
            } else {
              user.status = [
                { icon: "mdi-arrow-up-bold-circle", color: "success" },
              ];
            }
            return user;
          });
          if (toImport) _.$emit("isUpdated", true);
          _.files = null;
          _.selected = [];
        }
      });
    },
    open() {
      this.users = [];
      this.$refs.uploadUsersDialog.open();
    },
    onFileChange(e) {
      let _ = this;
      if (!_.files) return;
      if (_.files) {
        _.createCsv(_.files);
      }
    },
    createCsv(file) {
      let _ = this;
      _.csv = null;
      let reader = new FileReader();
      reader.onload = (e) => {
        _.csv = e.target.result;
        //console.dir(_.csv)
        _.loadData();
        _.files = null;
      };
      if (file) reader.readAsText(file, _.encoding);
    },
  },
  mounted() {
    this.users = [];
  },
};
</script>
<style lang="scss"></style>
